module.exports = __webpack_public_path__ + "img/nucleus_purple.86d69acf.svg";